import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, purple8 } from 'approot/shared/styles/colours.style';
import { fontSize18 } from 'approot/shared/styles/typography.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';
import { LAYOUT_HEADER_HEIGHT } from './layout.styles';

export const SkipLink = styled.a`
  background-color: ${purple8};
  height: 1px;
  position: absolute;
  width: 1px;
  text-align: left;
  overflow: hidden;

  &:focus {
    color: ${grey1};
    display: flex;
    align-items: center;
    padding: 0 ${rem(spacing24)};
    height: ${rem(LAYOUT_HEADER_HEIGHT)};
    font-size: ${rem(fontSize18)};
    position: fixed;
    overflow: visible;
    outline: 1px solid ${purple8};
    text-decoration: none;
    text-align: left;
    width: auto;
    z-index: 200;

    span {
      border: 1px solid ${grey1};
      border-radius: ${rem(4)};
      padding: ${rem(4)};
    }
  }
`;
